import { createAction } from "redux-starter-kit"

export const toggleSidebar = createAction("TOGGLE_SIDEBAR")
